module.exports = "<agents-payment-iframe #paymentFormComponent [paymentFormData]=\"paymentFormData\" (onPaymentRespond)=\"onPaymentRespond($event)\" ></agents-payment-iframe>\n<credit-agent-panel [agent]=\"agent\" [creditAgentFormData]=\"creditAgentFormData\"></credit-agent-panel>";


//////////////////
// WEBPACK FOOTER
// ./src/typescript/purchase/purchase-step.component.html
// module id = 1111
// module chunks = 1